/**
 * PUNTASO THEME - Main JavaScript
 * File: assets/puntazo.js
 */

/**
 * Formatea precio en centavos a string con símbolo de moneda.
 * Fallback si Shopify.formatMoney no está disponible.
 */
function formatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents);
  }
  const dollars = (cents / 100).toFixed(2);
  return `$${dollars}`;
}

/**
 * Gestor Central de Inventario y Stock en Carrito
 */
const CartStockManager = {
  stockCache: {}, // { variantId: { qty: number, policy: string, mgmt: string } }
  cartCache: {},  // { variantId: quantity }

  registerStock(variantId, qty, policy, mgmt) {
    if (!variantId) return;
    const vId = String(variantId);
    this.stockCache[vId] = {
      qty: (qty !== undefined && qty !== null && qty !== '') ? parseInt(qty, 10) : Infinity,
      policy: policy || 'deny',
      mgmt: mgmt || ''
    };
  },

  updateCartCache(cart) {
    this.cartCache = {};
    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(item => {
        const vId = String(item.variant_id);
        this.cartCache[vId] = (this.cartCache[vId] || 0) + item.quantity;
      });
    }
  },

  getQuantityInCart(variantId) {
    if (!variantId) return 0;
    return this.cartCache[String(variantId)] || 0;
  },

  shouldLimit(variantId) {
    if (!variantId) return false;
    const info = this.stockCache[String(variantId)];
    if (!info) return false;
    if (info.mgmt !== 'shopify') return false;
    if (info.policy === 'continue') return false;
    return Number.isFinite(info.qty);
  },

  getAvailableToAdd(variantId) {
    if (!variantId) return Infinity;
    const vId = String(variantId);
    if (!this.shouldLimit(vId)) return Infinity;
    const info = this.stockCache[vId];
    const inCart = this.getQuantityInCart(vId);
    return Math.max(0, info.qty - inCart);
  },

  getMaxAllowed(variantId) {
    if (!variantId) return Infinity;
    const vId = String(variantId);
    if (!this.shouldLimit(vId)) return Infinity;
    return this.stockCache[vId].qty;
  }
};
window.CartStockManager = CartStockManager;

const STOCK_LIMIT_MESSAGE = 'Has alcanzado el máximo disponible en stock para este producto';

document.addEventListener('DOMContentLoaded', () => {
  // Phase 7: Hidratación Inmediata (Wireframe)
  const cartState = localStorage.getItem('state-cart');
  if (cartState) {
    const isWithProducts = cartState === 'with-products';
    const toggleHidden = (selector, isHidden) => {
      const el = document.querySelector(selector);
      if (el) el.hidden = isHidden;
    };
    toggleHidden('[data-cart-items]', !isWithProducts);
    toggleHidden('[data-cart-empty]', isWithProducts);
    toggleHidden('[data-cart-footer]', !isWithProducts);
    toggleHidden('[data-cart-clear]', !isWithProducts);
    toggleHidden('[data-cart-view-link]', !isWithProducts);
    toggleHidden('[data-cart-divider]', !isWithProducts);
    toggleHidden('[data-cart-suggestions]', !isWithProducts);
  }

  initHeroSlideshow();
  initHorizontalCarousel();
  initFlyoutMenu();
  initUserMenu();
  initMobileMenu();
  initCartDrawer();
  initAddToCart();
  initScrollReveal();
  initBrandCarousel();
  initSearchBar();
  initProductGallery();
  initProductQty();
  initProductTabs();
  initProductAccordion();
  initCollectionFilters();
  initCartPage();
  initProductVariants();
  initCustomDropdowns();
  initFAQAccordion();
  initQuickView();

  // Favorites Logic
  initWishlistButtons();
  initFavoritesPage();

  // Recently Viewed Logic
  trackRecentlyViewed();
  initRecentlyViewed();

  // Department Page
  initDepartmentPage();

  // Initial cart badge update
  updateCartBadge();
});


/**
 * 1. HeroSlideshow
 * Selector: [data-hero-slideshow]
 */
function initHeroSlideshow() {
  const slideshows = document.querySelectorAll('[data-hero-slideshow]');

  slideshows.forEach(container => {
    const slides = container.querySelectorAll('[data-slide]');
    const prevBtn = container.querySelector('[data-prev]');
    const nextBtn = container.querySelector('[data-next]');
    const dots = container.querySelectorAll('[data-dot]');
    const autoplay = container.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(container.dataset.speed) || 5000;

    let currentIndex = 0;
    let timer = null;

    if (slides.length === 0) return;

    const goTo = (index) => {
      slides[currentIndex].classList.remove('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.remove('is-active');

      currentIndex = (index + slides.length) % slides.length;

      slides[currentIndex].classList.add('is-active');
      if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');

      if (autoplay) resetTimer();
    };

    const next = () => goTo(currentIndex + 1);
    const prev = () => goTo(currentIndex - 1);

    const resetTimer = () => {
      if (timer) clearInterval(timer);
      timer = setInterval(next, autoplaySpeed);
    };

    // Events
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goTo(i));
    });

    // Touch Support
    let touchStartX = 0;
    container.addEventListener('touchstart', e => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    container.addEventListener('touchend', e => {
      const touchEndX = e.changedTouches[0].screenX;
      if (touchStartX - touchEndX > 50) next();
      if (touchStartX - touchEndX < -50) prev();
    }, { passive: true });

    // Initialize
    if (autoplay) resetTimer();

    // Pausar autoplay al hacer hover
    if (autoplay) {
      container.addEventListener('mouseenter', () => {
        if (timer) clearInterval(timer);
      });
      container.addEventListener('mouseleave', () => {
        resetTimer();
      });
    }
  });
}

/**
 * 2. HorizontalCarousel
 * Selector: [data-carousel]
 */
function initHorizontalCarousel() {
  const containers = document.querySelectorAll('[data-carousel-container]');

  containers.forEach(container => {
    const track = container.querySelector('[data-carousel-track]');
    const prevBtn = container.querySelector('[data-prev]');
    const nextBtn = container.querySelector('[data-next]');

    if (!track) return;

    const updateButtons = () => {
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) {
        const atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth - 1;
        nextBtn.disabled = atEnd;
      }
    };

    if (container.dataset.carouselInitialized) {
      updateButtons();
      return;
    }

    container.dataset.carouselInitialized = 'true';

    const scroll = (direction) => {
      const firstChild = track.querySelector(':first-child');
      if (!firstChild) return;
      const itemWidth = firstChild.offsetWidth;
      const gap = 16;
      const scrollAmount = (itemWidth + gap) * (direction === 'next' ? 1 : -1);

      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    };

    if (prevBtn) prevBtn.addEventListener('click', () => scroll('prev'));
    if (nextBtn) nextBtn.addEventListener('click', () => scroll('next'));

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });

    // Initial state
    updateButtons();
  });
}

/**
 * 3. FlyoutMenu
 * Selector: [data-flyout]
 */
function initFlyoutMenu() {
  const flyoutTrigger = document.querySelector('[data-flyout-trigger]');
  const flyoutMenu = document.querySelector('[data-flyout-menu]');
  let isPinned = false;
  let leaveTimer = null;

  if (!flyoutTrigger || !flyoutMenu) return;

  const show = () => {
    if (leaveTimer) clearTimeout(leaveTimer);
    flyoutMenu.classList.add('is-visible');
    flyoutTrigger.classList.add('is-active');
  };

  const hide = () => {
    if (isPinned) return;
    leaveTimer = setTimeout(() => {
      flyoutMenu.classList.remove('is-visible');
      flyoutTrigger.classList.remove('is-active');
    }, 150);
  };

  flyoutTrigger.addEventListener('mouseenter', show);
  flyoutTrigger.addEventListener('mouseleave', hide);
  flyoutMenu.addEventListener('mouseenter', show);
  flyoutMenu.addEventListener('mouseleave', hide);

  flyoutTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    isPinned = !isPinned;
    if (isPinned) {
      show();
      flyoutTrigger.classList.add('is-pinned');
    } else {
      isPinned = false;
      flyoutTrigger.classList.remove('is-pinned');
      hide();
    }
  });

  // Department switching logic
  const deptItems = flyoutMenu.querySelectorAll('[data-dept-id]');
  const deptPanels = flyoutMenu.querySelectorAll('[data-dept-panel]');

  deptItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      const targetId = item.dataset.deptId;

      // Update active state in items
      deptItems.forEach(i => i.classList.remove('is-active'));
      item.classList.add('is-active');

      // Update active state in panels
      deptPanels.forEach(panel => {
        panel.classList.toggle('is-active', panel.dataset.deptPanel === targetId);
      });
    });
  });

  document.addEventListener('click', (e) => {
    if (isPinned && !flyoutMenu.contains(e.target) && !flyoutTrigger.contains(e.target)) {
      isPinned = false;
      flyoutTrigger.classList.remove('is-pinned');
      hide();
    }
  });
}

/**
 * 3.1 UserMenu
 */
function initUserMenu() {
  const toggle = document.querySelector('[data-user-menu-toggle]');
  const desktopMenu = document.querySelector('[data-user-menu-dropdown]');
  const mobileMenu = document.querySelector('[data-user-menu-mobile]');
  const closers = document.querySelectorAll('[data-user-menu-close]');

  if (!toggle) return;

  const toggleMenu = () => {
    if (window.innerWidth >= 640) {
      desktopMenu?.classList.toggle('is-open');
    } else {
      mobileMenu?.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  };

  const closeMenu = () => {
    desktopMenu?.classList.remove('is-open');
    mobileMenu?.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleMenu();
  });

  closers.forEach(btn => btn.addEventListener('click', closeMenu));

  // Close desktop menu on outside click
  document.addEventListener('click', (e) => {
    if (window.innerWidth >= 640 && desktopMenu?.classList.contains('is-open')) {
      if (!desktopMenu.contains(e.target) && !toggle.contains(e.target)) {
        closeMenu();
      }
    }
  });
}

/**
 * 4. MobileMenu
 */
function initMobileMenu() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    const isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });

  // Toggle subcategories
  const subToggles = menu.querySelectorAll('[data-mobile-toggle]');
  subToggles.forEach(btn => {
    btn.addEventListener('click', () => {
      const parent = btn.parentElement;
      const isOpen = parent.classList.toggle('is-active');
      btn.setAttribute('aria-expanded', isOpen);
    });
  });
}

/**
 * 5. CartDrawer
 */
function initCartDrawer() {
  const drawers = document.querySelectorAll('[data-cart-drawer]');
  const openers = document.querySelectorAll('[data-cart-open]');
  const closers = document.querySelectorAll('[data-cart-close]');

  const openDrawer = () => {
    drawers.forEach(d => d.classList.add('is-open'));
    document.body.style.overflow = 'hidden';
    renderCart();
  };

  const closeDrawer = () => {
    drawers.forEach(d => d.classList.remove('is-open'));
    document.body.style.overflow = '';
  };

  openers.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
  }));
  closers.forEach(btn => btn.addEventListener('click', closeDrawer));

  const clearBtns = document.querySelectorAll('[data-cart-clear]');
  clearBtns.forEach(btn => btn.addEventListener('click', async (e) => {
    e.preventDefault();
    // Feedback visual inmediato
    const cartItems = document.querySelectorAll('.cart-item');
    cartItems.forEach(item => {
      item.style.opacity = '0.5';
      item.style.pointerEvents = 'none';
    });

    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      await renderCart();
      if (typeof window.showToast === 'function') {
        window.showToast('Carrito vaciado', 'info');
      }
    } catch (err) {
      console.error('Error clearing cart', err);
      // Revert visual feedback on error
      cartItems.forEach(item => {
        item.style.opacity = '1';
        item.style.pointerEvents = 'auto';
      });
    }
  }));

  // Payment Option Toggle removed

  document.addEventListener('cart:updated', (e) => {
    updateCartUI(e.detail);
  });

  document.addEventListener('cart:refresh', () => {
    renderCart();
  });

  initCartSuggestionsListeners();

  // Render logic
  async function renderCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (err) {
      console.error('Error fetching cart', err);
    }
  }

  window.updateCartUI = function (cart) {
    const container = document.querySelector('[data-cart-items]');
    const emptyState = document.querySelector('[data-cart-empty]');
    const footer = document.querySelector('[data-cart-footer]');
    const totalEl = document.querySelector('[data-cart-total-price]');
    const clearBtn = document.querySelector('[data-cart-clear]');
    const viewLink = document.querySelector('[data-cart-view-link]');
    const divider = document.querySelector('[data-cart-divider]');
    const suggestions = document.querySelector('[data-cart-suggestions]');

    if (!container) return;

    const hasProducts = cart.item_count > 0;

    // Estandarización de Visibilidad
    if (container) container.hidden = !hasProducts;
    if (emptyState) emptyState.hidden = hasProducts;
    if (footer) footer.hidden = !hasProducts;
    if (clearBtn) clearBtn.hidden = !hasProducts;
    if (viewLink) viewLink.hidden = !hasProducts;
    if (divider) divider.hidden = !hasProducts;
    if (suggestions) suggestions.hidden = !hasProducts;

    // Persistencia Ligera en LocalStorage
    localStorage.setItem('state-cart', hasProducts ? 'with-products' : 'empty');

    CartStockManager.updateCartCache(cart);

    if (!hasProducts) {
      updateCartBadge(0);
      if (typeof loadCartSuggestions === 'function') loadCartSuggestions(null);
      return;
    }

    container.innerHTML = cart.items.map(item => {
      const vId = item.variant_id;
      const shouldLimit = CartStockManager.shouldLimit(vId);
      const maxAllowed = CartStockManager.getMaxAllowed(vId);
      const isAtMax = shouldLimit && item.quantity >= maxAllowed;
      const plusAttr = isAtMax ? ' class="is-max" disabled' : '';

      return `
      <div class="cart-item" data-id="${item.key}" data-variant-id="${vId}">
        <div class="cart-item__image">
          <img src="${item.image}" alt="${item.product_title}">
        </div>
        <div class="cart-item__info">
          <p class="cart-item__brand">${item.vendor || ''}</p>
          <p class="cart-item__title">${item.product_title}</p>
          <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
          <div class="cart-item__actions">
            <div class="cart-item__stepper">
              <button onclick="changeCartQty('${item.key}', ${item.quantity - 1}, ${item.quantity}, ${vId})">−</button>
              <span>${item.quantity}</span>
              <button${plusAttr} onclick="changeCartQty('${item.key}', ${item.quantity + 1}, ${item.quantity}, ${vId})">+</button>
            </div>
            <button class="cart-item__remove" onclick="changeCartQty('${item.key}', 0, ${item.quantity}, ${vId})" aria-label="Eliminar">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash-2"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>
            </button>
          </div>
        </div>
      </div>
    `;
    }).join('');

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    updateCartBadge(cart.item_count);
    
    if (cart.items.length > 0 && typeof loadCartSuggestions === 'function') {
      loadCartSuggestions(cart.items[0].product_id);
    }
  }

  /**
   * 5.1 Cart Suggestions Carousel
   */
  let currentSuggestionsProductId = null;
  let suggestionsCache = [];
  let currentSuggestionIndex = 0;

  function renderSuggestion(index) {
    const container = document.querySelector('[data-suggestion-container]');
    const nextBtn = document.querySelector('[data-suggestion-next]');
    const prevBtn = document.querySelector('[data-suggestion-prev]');
    if (!container || suggestionsCache.length === 0) return;

    const product = suggestionsCache[index];
    const firstVariant = product.variants && product.variants[0] ? product.variants[0] : null;
    const variantId = firstVariant ? firstVariant.id : null;
    const availableToAdd = variantId ? CartStockManager.getAvailableToAdd(variantId) : Infinity;
    const isOutOfStock = availableToAdd <= 0;

    container.innerHTML = `
      <div class="cart-drawer__suggestion-image">
        <img src="${product.featured_image}" alt="${product.title}">
      </div>
      <div class="cart-drawer__suggestion-info">
        <p class="cart-item__brand" style="margin-bottom:2px">${product.vendor || ''}</p>
        <p class="cart-drawer__suggestion-name">${product.title}</p>
        <div style="display:flex; justify-content:space-between; align-items:center; margin-top:4px;">
          <p class="cart-drawer__suggestion-price">${formatMoney(product.price)}</p>
          <button 
            class="cart-drawer__suggestion-add${isOutOfStock ? ' is-max' : ''}" 
            ${isOutOfStock ? 'disabled' : ''} 
            onclick="addItemToCart(${variantId}, this)" 
            aria-label="Añadir"
          >
            ${isOutOfStock ? 'Máximo alcanzado' : 'Añadir al carrito'}
          </button>
        </div>
      </div>
    `;

    if (prevBtn) prevBtn.disabled = index === 0;
    if (nextBtn) nextBtn.disabled = index === suggestionsCache.length - 1;
  }

  window.loadCartSuggestions = async function(productId) {
    const wrapper = document.querySelector('[data-cart-suggestions]');
    if (!wrapper) return;

    if (!productId) {
      wrapper.style.display = 'none';
      return;
    }

    if (productId === currentSuggestionsProductId) {
      wrapper.style.display = 'block';
      return;
    }

    currentSuggestionsProductId = productId;

    try {
      const url = `/recommendations/products.json?product_id=${productId}&limit=4`;
      const res = await fetch(url);
      const data = await res.json();
      suggestionsCache = data.products || [];

      // Registrar inventario de variantes sugeridas
      suggestionsCache.forEach(prod => {
        if (prod.variants && Array.isArray(prod.variants)) {
          prod.variants.forEach(v => {
            CartStockManager.registerStock(v.id, v.inventory_quantity, v.inventory_policy, v.inventory_management);
          });
        }
      });

      if (suggestionsCache.length === 0) {
        wrapper.style.display = 'none';
      } else {
        wrapper.style.display = 'block';
        currentSuggestionIndex = 0;
        renderSuggestion(0);
      }
    } catch (e) {
      console.error('Error loading suggestions', e);
      wrapper.style.display = 'none';
    }
  };

  function initCartSuggestionsListeners() {
    const nextBtn = document.querySelector('[data-suggestion-next]');
    const prevBtn = document.querySelector('[data-suggestion-prev]');

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (currentSuggestionIndex < suggestionsCache.length - 1) {
          currentSuggestionIndex++;
          renderSuggestion(currentSuggestionIndex);
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        if (currentSuggestionIndex > 0) {
          currentSuggestionIndex--;
          renderSuggestion(currentSuggestionIndex);
        }
      });
    }
  }
}

// Global helper for showing premium toast notifications
window.showPuntazoToast = function (message, type = 'info') {
  const toast = document.createElement('div');
  toast.className = `puntazo-toast puntazo-toast--${type}`;
  toast.setAttribute('role', 'alert');

  let iconHtml = '';
  if (type === 'success') {
    iconHtml = `<span class="puntazo-toast__icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand-green, #339a47)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg></span>`;
  } else if (type === 'error') {
    iconHtml = `<span class="puntazo-toast__icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand-red, #c1121f)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg></span>`;
  } else {
    iconHtml = `<span class="puntazo-toast__icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand-blue, #033f87)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg></span>`;
  }

  toast.innerHTML = `${iconHtml}<span class="puntazo-toast__message">${message}</span>`;
  document.body.appendChild(toast);

  // Trigger entering animation
  requestAnimationFrame(() => {
    toast.classList.add('is-active');
  });

  // Self-destruct after 4 seconds
  setTimeout(() => {
    toast.classList.remove('is-active');
    setTimeout(() => {
      toast.remove();
    }, 400);
  }, 4000);
};

// Global helper for adding suggestion to cart
window.addItemToCart = async function (variantId, btn) {
  if (!variantId) return;

  if (CartStockManager.shouldLimit(variantId)) {
    const available = CartStockManager.getAvailableToAdd(variantId);
    if (available <= 0) {
      window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
      if (btn) {
        btn.classList.add('is-max');
        btn.disabled = true;
      }
      return;
    }
  }

  if (btn) {
    btn.innerHTML = '¡Añadido!';
    btn.classList.add('is-added');
    setTimeout(() => {
      btn.innerHTML = 'Añadir al carrito';
      btn.classList.remove('is-added');
    }, 1500);
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    
    if (!response.ok) {
      const errorJson = await response.json();
      throw new Error(errorJson.description || errorJson.message || 'No se pudo agregar al carrito.');
    }

    window.showPuntazoToast('Producto agregado al carrito exitosamente.', 'success');
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (typeof updateCartBadge === 'function') updateCartBadge();
  } catch (err) {
    console.error('Error adding suggestion to cart', err);
    if (btn) {
      btn.innerHTML = 'Añadir al carrito';
      btn.classList.remove('is-added');
    }
    window.showPuntazoToast(err.message || 'No se pudo agregar al carrito. Intenta de nuevo.', 'error');
  }
};

// Global helper for cart quantity
window.changeCartQty = async function (key, qty, currentQty = null, variantId = null) {
  // Verificación de stock antes de incrementar
  if (qty > (currentQty || 0) && variantId && CartStockManager.shouldLimit(variantId)) {
    const maxStock = CartStockManager.getMaxAllowed(variantId);
    if (qty > maxStock) {
      window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
      return;
    }
  }

  // Optimistic UI Update
  const row = document.querySelector(`[data-id="${key}"]`);
  let originalState = null;
  let span = null;
  let originalOpacity = '';
  let originalPointerEvents = '';

  if (row) {
    originalOpacity = row.style.opacity;
    originalPointerEvents = row.style.pointerEvents;
    
    if (qty === 0) {
      row.style.opacity = '0.5';
      row.style.pointerEvents = 'none';
    } else {
      row.style.opacity = '0.5';
      row.style.pointerEvents = 'none';
      span = row.querySelector('.cart-item__stepper span');
      if (span) {
        originalState = span.textContent;
        span.textContent = qty;
      }
    }
  }

  // Optimistic Badge Update
  const badge = document.querySelector('[data-cart-count]');
  let originalCount = 0;
  if (badge && currentQty !== null) {
    originalCount = parseInt(badge.textContent) || 0;
    const diff = qty - currentQty;
    const newCount = Math.max(0, originalCount + diff);
    badge.textContent = newCount;
    badge.style.display = newCount > 0 ? 'flex' : 'none';
  }

  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    
    if (!response.ok) throw new Error('Cart update failed');
    
    const cart = await response.json();
    CartStockManager.updateCartCache(cart);
    const container = document.querySelector('[data-cart-items]');
    if (container) {
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    }
    
    // Restore styling if the row is still there
    if (row && document.body.contains(row) && qty > 0) {
      row.style.opacity = originalOpacity;
      row.style.pointerEvents = originalPointerEvents;
    }
  } catch (err) {
    console.error('Error changing cart qty optimistically', err);
    
    // Revert UI
    if (row && document.body.contains(row)) {
      row.style.opacity = originalOpacity;
      row.style.pointerEvents = originalPointerEvents;
      if (span && originalState !== null) {
        span.textContent = originalState;
      }
    }
    if (badge && currentQty !== null) {
      badge.textContent = originalCount;
      badge.style.display = originalCount > 0 ? 'flex' : 'none';
    }
    
    window.showPuntazoToast('No se pudo actualizar el carrito. Intenta de nuevo.', 'error');
  }
};

/**
 * 6. AddToCart & Stepper
 */
function pzEnsureSpinnerStyles() {
  if (document.getElementById('pz-spinner-styles')) return;
  const style = document.createElement('style');
  style.id = 'pz-spinner-styles';
  style.textContent = `
    [data-add-to-cart].is-loading { pointer-events: none; cursor: wait; opacity: .85; }
    .pz-spinner {
      display: inline-block;
      width: 16px; height: 16px;
      border: 2px solid currentColor;
      border-right-color: transparent;
      border-radius: 50%;
      animation: pz-spin .6s linear infinite;
      vertical-align: middle;
    }
    @keyframes pz-spin { to { transform: rotate(360deg); } }
  `;
  document.head.appendChild(style);
}

function initAddToCart() {
  pzEnsureSpinnerStyles();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    // Si ya se está procesando, ignorar el clic (evita duplicados)
    if (btn.classList.contains('is-loading')) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    // Registrar stock si los atributos están presentes
    CartStockManager.registerStock(
      variantId,
      btn.dataset.inventoryQty,
      btn.dataset.inventoryPolicy,
      btn.dataset.inventoryManagement
    );

    // Validar si hay stock disponible para añadir al menos 1 unidad
    if (CartStockManager.shouldLimit(variantId)) {
      const available = CartStockManager.getAvailableToAdd(variantId);
      if (available <= 0) {
        window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
        return;
      }
    }

    const allBtns = document.querySelectorAll(`[data-add-to-cart][data-variant-id="${variantId}"]`);
    const allSteppers = [];
    allBtns.forEach(b => {
      const container = b.closest('.product-card__actions');
      if (container) {
        const s = container.querySelector('[data-stepper]');
        if (s) allSteppers.push(s);
      }
    });

    // Guardar tamaño para que el botón no se encoja con el spinner
    allBtns.forEach(b => {
      if (!b.dataset.originalHtml) {
        b.dataset.originalHtml = b.innerHTML;
        b.style.minWidth = b.offsetWidth + 'px';
        b.style.minHeight = b.offsetHeight + 'px';
      }
      b.classList.add('is-loading');
      b.setAttribute('aria-busy', 'true');
      b.disabled = true;
      b.innerHTML = '<span class="pz-spinner" aria-hidden="true"></span>';
    });

    const restoreBtns = () => {
      allBtns.forEach(b => {
        b.classList.remove('is-loading');
        b.removeAttribute('aria-busy');
        b.disabled = false;
        if (b.dataset.originalHtml) {
          b.innerHTML = b.dataset.originalHtml;
          delete b.dataset.originalHtml;
        }
        b.style.minWidth = '';
        b.style.minHeight = '';
      });
    };

    // El spinner se muestra MINIMO 500ms para que sea visible
    const startedAt = Date.now();
    const MIN_SPINNER_MS = 500;
    const finish = (accion) => {
      const espera = Math.max(0, MIN_SPINNER_MS - (Date.now() - startedAt));
      setTimeout(accion, espera);
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(async res => {
      if (!res.ok) {
        const errorJson = await res.json();
        throw new Error(errorJson.description || errorJson.message || 'No se pudo agregar al carrito.');
      }

      finish(async () => {
        restoreBtns();
        allBtns.forEach(b => b.setAttribute('hidden', ''));
        
        const isLimit = CartStockManager.shouldLimit(variantId);
        const maxStock = CartStockManager.getMaxAllowed(variantId);

        allSteppers.forEach(s => {
          s.removeAttribute('hidden');
          const qtyEl = s.querySelector('[data-qty]');
          if (qtyEl) qtyEl.textContent = '1';

          const plus = s.querySelector('[data-plus]');
          if (plus) {
            if (isLimit && 1 >= maxStock) {
              plus.classList.add('is-max');
              plus.disabled = true;
            } else {
              plus.classList.remove('is-max');
              plus.disabled = false;
            }
          }
        });

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        updateCartBadge();
        window.showPuntazoToast('Producto agregado al carrito exitosamente.', 'success');
      });
    }).catch(err => {
      console.error('Error adding to cart', err);
      finish(() => {
        restoreBtns();
        window.showPuntazoToast(err.message || 'No se pudo agregar al carrito. Intenta de nuevo.', 'error');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        updateCartBadge();
      });
    });
  });

  // Listener para el formulario principal de la página de producto
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;

    e.preventDefault();
    const btn = form.querySelector('[data-submit-button]');
    const formData = new FormData(form);
    const quantity = parseInt(formData.get('quantity') || 1);
    const variantId = formData.get('id');

    if (!variantId) return;

    // Validación de stock antes de submit
    if (CartStockManager.shouldLimit(variantId)) {
      const available = CartStockManager.getAvailableToAdd(variantId);
      if (quantity > available) {
        window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
        return;
      }
    }

    let originalText = '';
    if (btn) {
      originalText = btn.innerHTML;
      btn.innerHTML = `<span class="btn__icon"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"></path></svg></span>¡AÑADIDO!`;
      btn.classList.add('is-added');
      btn.setAttribute('disabled', 'true');
    }

    const badge = document.querySelector('[data-cart-count]');
    let originalCount = 0;
    if (badge) {
      originalCount = parseInt(badge.textContent) || 0;
      badge.textContent = originalCount + quantity;
      badge.style.display = 'flex';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    }).then(async res => {
      if (!res.ok) {
        const errorJson = await res.json();
        throw new Error(errorJson.description || errorJson.message || 'No se pudo agregar al carrito.');
      }
      updateCartBadge();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.showPuntazoToast('Producto agregado al carrito exitosamente.', 'success');

      setTimeout(() => {
        if (btn) {
          btn.innerHTML = originalText;
          btn.classList.remove('is-added');
          btn.removeAttribute('disabled');
        }
      }, 1500);
    }).catch(err => {
      console.error('Error optimistically adding to cart from form', err);
      if (btn) {
        btn.innerHTML = originalText;
        btn.classList.remove('is-added');
        btn.removeAttribute('disabled');
      }
      if (badge) {
        badge.textContent = originalCount;
        badge.style.display = originalCount > 0 ? 'flex' : 'none';
      }
      updateCartBadge();
      window.showPuntazoToast(err.message || 'No se pudo agregar al carrito. Intenta de nuevo.', 'error');
    });
  });

  // Listener para botones del stepper (+/-)
  document.addEventListener('click', (e) => {
    const plusBtn = e.target.closest('[data-plus]');
    const minusBtn = e.target.closest('[data-minus]');

    if (plusBtn || minusBtn) {
      const clickedStepper = (plusBtn || minusBtn).closest('[data-stepper]');
      const container = clickedStepper?.closest('.product-card__actions');
      const atcBtn = container?.querySelector('[data-add-to-cart]');
      const variantId = clickedStepper?.dataset.variantId || atcBtn?.dataset.variantId;
      if (!variantId) return;

      // Registrar stock si existen los atributos
      CartStockManager.registerStock(
        variantId,
        clickedStepper?.dataset.inventoryQty || atcBtn?.dataset.inventoryQty,
        clickedStepper?.dataset.inventoryPolicy || atcBtn?.dataset.inventoryPolicy,
        clickedStepper?.dataset.inventoryManagement || atcBtn?.dataset.inventoryManagement
      );

      const clickedQtyEl = clickedStepper.querySelector('[data-qty]');
      if (!clickedQtyEl) return;

      const currentQty = parseInt(clickedQtyEl.textContent) || 1;
      const isLimit = CartStockManager.shouldLimit(variantId);
      const maxStock = CartStockManager.getMaxAllowed(variantId);

      // Si es incremento y ya alcanzamos el stock máximo permitido
      if (plusBtn && isLimit && currentQty >= maxStock) {
        plusBtn.classList.add('is-max');
        plusBtn.disabled = true;
        window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
        return;
      }

      let qty = plusBtn ? currentQty + 1 : Math.max(0, currentQty - 1);

      const allBtns = document.querySelectorAll(`[data-add-to-cart][data-variant-id="${variantId}"]`);
      const allSteppers = [];
      allBtns.forEach(b => {
        const wrap = b.closest('.product-card__actions');
        if (wrap) {
          const s = wrap.querySelector('[data-stepper]');
          if (s) allSteppers.push(s);
        }
      });

      if (qty === 0) {
        allSteppers.forEach(s => s.setAttribute('hidden', ''));
        allBtns.forEach(b => b.removeAttribute('hidden'));
      } else {
        allSteppers.forEach(s => {
          const qEl = s.querySelector('[data-qty]');
          if (qEl) qEl.textContent = qty;

          const pBtn = s.querySelector('[data-plus]');
          if (pBtn) {
            if (isLimit && qty >= maxStock) {
              pBtn.classList.add('is-max');
              pBtn.disabled = true;
            } else {
              pBtn.classList.remove('is-max');
              pBtn.disabled = false;
            }
          }
        });
      }

      const badge = document.querySelector('[data-cart-count]');
      if (badge) {
        let count = parseInt(badge.textContent) || 0;
        let diff = plusBtn ? 1 : -1;
        count = Math.max(0, count + diff);
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }).then(async res => {
        if (!res.ok) {
          const errorJson = await res.json();
          throw new Error(errorJson.description || errorJson.message || 'Error al cambiar cantidad');
        }
        const cart = await res.json();
        CartStockManager.updateCartCache(cart);
        updateCartBadge();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }).catch(err => {
        console.error('Error changing qty', err);
        window.showPuntazoToast(err.message || 'No se pudo actualizar la cantidad.', 'error');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        updateCartBadge();
      });
    }
  });
}
/**
 * 7. CartBadge
 */
async function updateCartBadge(count) {
  const badge = document.querySelector('[data-cart-count]');
  if (!badge) return;

  if (count !== undefined) {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  } else {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    badge.textContent = cart.item_count;
    badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
  }
}

/**
 * 8. ScrollReveal
 */
function initScrollReveal() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));
}

/**
 * 9. BrandCarousel
 */
function initBrandCarousel() {
  const tracks = document.querySelectorAll('[data-brand-track]');
  tracks.forEach(track => {
    // Simple infinite loop helper if needed, 
    // but mostly handled by CSS animations
  });
}

/**
 * 10. SearchBar
 */
function initSearchBar() {
  const toggle = document.querySelector('[data-search-toggle]');
  const mobileSearch = document.querySelector('[data-search-mobile]');
  const desktopSearchInput = document.querySelector('[data-search-desktop] input');
  const mobileSearchInput = document.querySelector('[data-search-mobile] input');

  if (toggle && mobileSearch) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileSearch.classList.toggle('is-open');
      toggle.classList.toggle('is-active', isOpen);
      if (isOpen) {
        setTimeout(() => mobileSearchInput?.focus(), 100);
      }
    });
  }

  const searchForms = document.querySelectorAll('.header__search-form');
  searchForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const query = this.querySelector('input[name="q"]').value.trim();
      if (query) window.location.href = `${form.action}?q=${encodeURIComponent(query)}`;
    });
  });
}

/**
 * 11. Product Detail Features
 */
function initProductGallery() {
  const containers = document.querySelectorAll('[data-product-container]');

  containers.forEach(container => {
    const mainImage = container.querySelector('[data-main-image]');
    const thumbnails = container.querySelectorAll('[data-thumbnail]');

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        const newSrc = thumb.dataset.thumbnail;
        if (mainImage) {
          mainImage.src = newSrc;
          // Update active class
          thumbnails.forEach(t => t.classList.remove('is-active'));
          thumb.classList.add('is-active');
        }
      });
    });

    // Zoom Feature
    const mainContainer = container.querySelector('[data-main-image-container]');
    if (mainContainer && mainImage) {
      mainContainer.addEventListener('mousemove', (e) => {
        const { left, top, width, height } = mainContainer.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;

        mainImage.style.setProperty('--zoom-x', `${x}%`);
        mainImage.style.setProperty('--zoom-y', `${y}%`);
      });

      mainContainer.addEventListener('mouseenter', () => {
        mainContainer.classList.add('is-zoomed');
      });

      mainContainer.addEventListener('mouseleave', () => {
        mainContainer.classList.remove('is-zoomed');
        mainImage.style.removeProperty('--zoom-x');
        mainImage.style.removeProperty('--zoom-y');
      });
    }
  });
}

function initProductQty() {
  const containers = document.querySelectorAll('[data-product-container]');

  containers.forEach(container => {
    const input = container.querySelector('[data-qty-input]');
    const plus = container.querySelector('[data-qty-plus]');
    const minus = container.querySelector('[data-qty-minus]');
    const qtySelector = container.querySelector('[data-pdp-qty-selector]');
    const idInput = container.querySelector('[data-product-id-input]');

    if (!input) return;

    const getVariantId = () => {
      return idInput?.value || qtySelector?.dataset.variantId;
    };

    // Registrar stock inicial si está presente
    if (qtySelector && getVariantId()) {
      CartStockManager.registerStock(
        getVariantId(),
        qtySelector.dataset.inventoryQty,
        qtySelector.dataset.inventoryPolicy,
        qtySelector.dataset.inventoryManagement
      );
    }

    const updatePlusButtonState = () => {
      const vId = getVariantId();
      if (!vId || !CartStockManager.shouldLimit(vId)) {
        plus?.classList.remove('is-max');
        if (plus) plus.disabled = false;
        return;
      }
      const available = CartStockManager.getAvailableToAdd(vId);
      const val = parseInt(input.value) || 1;
      const atMax = available <= 0 || val >= available;
      plus?.classList.toggle('is-max', atMax);
      if (plus) plus.disabled = atMax;
    };

    plus?.addEventListener('click', () => {
      const vId = getVariantId();
      const currentVal = parseInt(input.value) || 1;

      if (vId && CartStockManager.shouldLimit(vId)) {
        const available = CartStockManager.getAvailableToAdd(vId);
        if (available <= 0 || currentVal >= available) {
          plus.classList.add('is-max');
          plus.disabled = true;
          window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
          return;
        }
      }

      input.value = currentVal + 1;
      updatePlusButtonState();
    });

    minus?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) {
        input.value = val - 1;
      }
      updatePlusButtonState();
    });

    const handleValueClamping = () => {
      let val = parseInt(input.value);
      if (isNaN(val) || val < 1) val = 1;

      const vId = getVariantId();
      if (vId && CartStockManager.shouldLimit(vId)) {
        const available = CartStockManager.getAvailableToAdd(vId);
        if (available > 0 && val > available) {
          val = available;
          window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
        } else if (available <= 0) {
          val = 1;
          window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
        }
      }

      input.value = val;
      updatePlusButtonState();
    };

    input.addEventListener('change', handleValueClamping);
    input.addEventListener('input', handleValueClamping);

    // Estado inicial
    updatePlusButtonState();
  });
}

function initProductTabs() {
  const containers = document.querySelectorAll('[data-product-container]');

  containers.forEach(container => {
    const tabs = container.querySelectorAll('[data-tab]');
    const panes = container.querySelectorAll('[data-pane]');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;

        // On mobile and desktop there might be multiple tabs with same dataset.tab
        // We sync them by selecting all tabs/panes in the container with that target
        container.querySelectorAll(`[data-tab]`).forEach(t => {
          t.classList.toggle('is-active', t.dataset.tab === target);
        });
        container.querySelectorAll(`[data-pane]`).forEach(p => {
          p.classList.toggle('is-active', p.dataset.pane === target);
        });
      });
    });
  });
}

function initProductAccordion() {
  window.initProductAccordion = initProductAccordion;
  const containers = document.querySelectorAll('[data-product-container]');

  containers.forEach(container => {
    if (container.dataset.accordionInitialized) return;
    container.dataset.accordionInitialized = 'true';

    const trigger = container.querySelector('[data-accordion-trigger]');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', !isExpanded);
    });
  });
}

/**
 * 12. Collection Page Filters & Sort
 */
function initCollectionFilters() {
  // Accordion logic for sidebar
  const triggers = document.querySelectorAll('[data-accordion-trigger]');
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      const content = trigger.nextElementSibling;
      const isOpen = content.classList.contains('is-open');

      if (isOpen) {
        content.classList.remove('is-open');
        trigger.classList.remove('is-active');
      } else {
        content.classList.add('is-open');
        trigger.classList.add('is-active');
      }
    });
  });

  // Mobile Sort Drawer
  const openBtn = document.querySelector('[data-mobile-sort-open]');
  const closeBtn = document.querySelector('[data-mobile-sort-close]');
  const drawer = document.querySelector('[data-mobile-sort-drawer]');

  if (openBtn && drawer) {
    openBtn.addEventListener('click', () => {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (closeBtn && drawer) {
    closeBtn.addEventListener('click', () => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
}

/**
 * 13. Cart Page Logic
 */
function initCartPage() {
  window.initCartPage = initCartPage;
  const container = document.querySelector('[data-cart-page-container]');
  if (!container) return;

  // Partial section refresh using Shopify Section Rendering API
  async function refreshCartPage() {
    const currentContainer = document.querySelector('[data-cart-page-container]');
    if (!currentContainer) return;
    
    // Obtener el ID de la sección dinámicamente o usar fallback
    const sectionId = currentContainer.dataset.sectionId || 'main-cart';

    try {

      const response = await fetch(`/cart?sections=${sectionId}`);
      if (!response.ok) throw new Error('Error al conectar con Shopify');

      const json = await response.json();
      const sectionHtml = json[sectionId];
      if (sectionHtml) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHtml, 'text/html');
        const newContainer = doc.querySelector('[data-cart-page-container]');
        if (newContainer) {
          currentContainer.outerHTML = newContainer.outerHTML;
          // Re-initialize events on the new DOM node
          initCartPage();
          if (typeof window.initProductAccordion === 'function') window.initProductAccordion();
          
          // Sync header badges/drawers
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (typeof updateCartBadge === 'function') {
            updateCartBadge();
          }
        }
      }
    } catch (err) {
      console.error('Error refreshing cart page', err);
      window.showPuntazoToast('Error al actualizar la vista del carrito.', 'error');
    }
  }

  // Quantity and Removal click handler
  container.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-item-remove]');

    if (qtyBtn) {
      const key = qtyBtn.dataset.qtyChange;
      const delta = parseInt(qtyBtn.dataset.qtyDelta);
      const stepper = qtyBtn.closest('.stepper');
      if (stepper) {
        const variantId = stepper.dataset.variantId;
        if (variantId) {
          CartStockManager.registerStock(
            variantId,
            stepper.dataset.inventoryQty,
            stepper.dataset.inventoryPolicy,
            stepper.dataset.inventoryManagement
          );
        }

        const valEl = stepper.querySelector('.stepper__value');
        const currentQty = parseInt(valEl.textContent);

        // Bloqueo preventivo si se incrementa más allá del inventario disponible
        if (delta > 0 && variantId && CartStockManager.shouldLimit(variantId)) {
          const maxAllowed = CartStockManager.getMaxAllowed(variantId);
          if (currentQty >= maxAllowed) {
            qtyBtn.classList.add('is-max');
            qtyBtn.disabled = true;
            window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
            return;
          }
        }

        const newQty = Math.max(0, currentQty + delta);

        // Optimistic UI updates
        const originalQty = valEl.textContent;
        valEl.textContent = newQty;

        // Apply opacity ONLY to this specific item
        const cartItem = qtyBtn.closest('[data-cart-item]');
        let originalOpacity = '';
        if (cartItem) {
          originalOpacity = cartItem.style.opacity;
          cartItem.style.opacity = '0.5';
        }

        updateCartItem(key, newQty, () => {
          // Rollback on failure
          valEl.textContent = originalQty;
          if (cartItem) cartItem.style.opacity = originalOpacity;
        });
      }
    }

    if (removeBtn) {
      const key = removeBtn.dataset.itemRemove;
      const cartItem = removeBtn.closest('[data-cart-item]');
      let originalOpacity = '';
      if (cartItem) {
        originalOpacity = cartItem.style.opacity;
        cartItem.style.opacity = '0.4';
      }
      updateCartItem(key, 0, () => {
        if (cartItem) cartItem.style.opacity = originalOpacity;
      });
    }
  });

  async function updateCartItem(key, qty, rollback = null) {

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });

      if (!response.ok) {
        const errorJson = await response.json();
        throw new Error(errorJson.description || errorJson.message || 'Inventario insuficiente');
      }

      const cart = await response.json();
      CartStockManager.updateCartCache(cart);
      await refreshCartPage();
    } catch (err) {
      console.error('Error updating cart item', err);
      if (rollback) rollback();
      window.showPuntazoToast(err.message || 'No se pudo actualizar el carrito.', 'error');
    }
  }

  // Handle suggestion adds
  const suggestionsContainer = container.querySelector('[data-suggestions-container]');
  if (suggestionsContainer) {
    suggestionsContainer.addEventListener('click', async (e) => {
      const atcBtn = e.target.closest('[data-add-to-cart]');
      if (atcBtn) {
        e.preventDefault();
        e.stopPropagation();

        const variantId = atcBtn.dataset.variantId;
        if (variantId) {
          CartStockManager.registerStock(
            variantId,
            atcBtn.dataset.inventoryQty,
            atcBtn.dataset.inventoryPolicy,
            atcBtn.dataset.inventoryManagement
          );

          if (CartStockManager.shouldLimit(variantId)) {
            const available = CartStockManager.getAvailableToAdd(variantId);
            if (available <= 0) {
              window.showPuntazoToast(STOCK_LIMIT_MESSAGE, 'info');
              return;
            }
          }
        }

        const originalText = atcBtn.textContent;
        atcBtn.textContent = 'Añadiendo...';
        atcBtn.style.pointerEvents = 'none';

        // Apply opacity ONLY to this specific suggestion item
        const sugItem = atcBtn.closest('[data-suggestion-item]');
        let originalOpacity = '';
        if (sugItem) {
          originalOpacity = sugItem.style.opacity;
          sugItem.style.opacity = '0.5';
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: atcBtn.dataset.variantId, quantity: 1 })
          });

          if (!response.ok) {
            const errorJson = await response.json();
            throw new Error(errorJson.description || errorJson.message || 'No se pudo añadir el producto.');
          }

          atcBtn.textContent = '¡Añadido!';
          atcBtn.classList.add('is-added');
          window.showPuntazoToast('Producto agregado exitosamente.', 'success');

          await refreshCartPage();
        } catch (err) {
          console.error('Error adding suggestion to cart', err);
          atcBtn.textContent = originalText;
          atcBtn.style.pointerEvents = '';
          if (sugItem) {
            sugItem.style.opacity = originalOpacity;
          }
          window.showPuntazoToast(err.message || 'Inventario insuficiente o error al añadir.', 'error');
        }
      }
    });
  }

  // Simple Suggestions Navigation (Pagination simulation)
  const sugPrev = container.querySelector('[data-suggestion-prev]');
  const sugNext = container.querySelector('[data-suggestion-next]');
  const sugContainer = container.querySelector('[data-suggestions-container]');

  if (sugContainer) {
    let page = 0;

    const updateSugs = () => {
      const items = sugContainer.querySelectorAll('[data-suggestion-item]');
      const maxPage = Math.max(0, Math.ceil(items.length / 2) - 1);

      // Keep page in bounds
      if (page > maxPage) page = maxPage;
      if (page < 0) page = 0;

      // Show exactly 2 items per page
      items.forEach((item, i) => {
        const show = (i >= page * 2) && (i < (page + 1) * 2);
        item.style.display = show ? 'flex' : 'none';
      });

      // Update navigation button visibility and disabled states
      if (sugPrev && sugNext) {
        if (items.length > 2) {
          sugPrev.style.display = '';
          sugNext.style.display = '';
          sugPrev.disabled = page === 0;
          sugNext.disabled = page === maxPage;
        } else {
          sugPrev.style.display = 'none';
          sugNext.style.display = 'none';
        }
      }
    };

    if (sugPrev && sugNext) {
      sugPrev.addEventListener('click', () => {
        if (page > 0) {
          page--;
          updateSugs();
        }
      });
      sugNext.addEventListener('click', () => {
        const items = sugContainer.querySelectorAll('[data-suggestion-item]');
        const maxPage = Math.max(0, Math.ceil(items.length / 2) - 1);
        if (page < maxPage) {
          page++;
          updateSugs();
        }
      });
    }

    // Run on load
    updateSugs();
  }

  // Intercept checkout button
  const checkoutBtn = container.querySelector('[data-cart-checkout-btn]');
  if (checkoutBtn && !checkoutBtn.dataset.checkoutIntercepted) {
    checkoutBtn.dataset.checkoutIntercepted = 'true';
    checkoutBtn.addEventListener('click', (e) => {
      const badge = document.querySelector('[data-cart-count]');
      const count = badge ? parseInt(badge.textContent) || 0 : 0;
      if (count === 0) {
        e.preventDefault();
        window.showPuntazoToast('Tu carrito está vacío.', 'error');
      }
    });
  }
}

/**
 * 15. Sincronización de Product Cards con Carrito
 */
function syncProductCardsWithCart(cart) {
  const cards = document.querySelectorAll('[data-product-card]');
  if (!cards.length) return;

  CartStockManager.updateCartCache(cart);

  const cartQtys = {};
  if (cart && cart.items) {
    cart.items.forEach(item => {
      cartQtys[item.variant_id] = (cartQtys[item.variant_id] || 0) + item.quantity;
    });
  }

  const allBtns = document.querySelectorAll('[data-add-to-cart]');
  allBtns.forEach(atcBtn => {
    const variantId = atcBtn.dataset.variantId;
    if (!variantId) return;

    const container = atcBtn.closest('.product-card__actions');
    if (!container) return;

    const stepper = container.querySelector('[data-stepper]');
    const qtyEl = container.querySelector('[data-qty]');
    const plusBtn = stepper?.querySelector('[data-plus]');
    
    // Registrar stock de los data-attributes si existen
    CartStockManager.registerStock(
      variantId,
      atcBtn.dataset.inventoryQty || stepper?.dataset.inventoryQty,
      atcBtn.dataset.inventoryPolicy || stepper?.dataset.inventoryPolicy,
      atcBtn.dataset.inventoryManagement || stepper?.dataset.inventoryManagement
    );

    const isLimit = CartStockManager.shouldLimit(variantId);
    const maxStock = CartStockManager.getMaxAllowed(variantId);
    const cartQty = cartQtys[variantId] || 0;

    if (!stepper || !qtyEl) return;

    if (cartQty > 0) {
      atcBtn.setAttribute('hidden', '');
      stepper.removeAttribute('hidden');
      qtyEl.textContent = cartQty;

      if (plusBtn) {
        const isAtMax = isLimit && cartQty >= maxStock;
        plusBtn.classList.toggle('is-max', isAtMax);
        plusBtn.disabled = isAtMax;
      }
    } else {
      stepper.setAttribute('hidden', '');
      atcBtn.removeAttribute('hidden');
      qtyEl.textContent = '1';

      if (plusBtn) {
        plusBtn.classList.remove('is-max');
        plusBtn.disabled = false;
      }

      if (isLimit && CartStockManager.getAvailableToAdd(variantId) <= 0) {
        atcBtn.disabled = true;
      } else {
        atcBtn.disabled = false;
      }
    }
  });
}

document.addEventListener('cart:updated', (e) => {
  if (e.detail) syncProductCardsWithCart(e.detail);
  
  // Refrescar layout principal del carrito si estamos en la página del carrito
  const cartPageContainer = document.querySelector('[data-cart-page-container]');
  if (cartPageContainer) {
    const sectionId = cartPageContainer.dataset.sectionId || 'main-cart';
    fetch(`/cart?sections=${sectionId}`)
      .then(res => res.json())
      .then(json => {
        const sectionHtml = json[sectionId];
        if (sectionHtml) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(sectionHtml, 'text/html');
          const newContainer = doc.querySelector('[data-cart-page-container]');
          if (newContainer) {
            cartPageContainer.outerHTML = newContainer.outerHTML;
            if (typeof window.initCartPage === 'function') window.initCartPage();
            if (typeof window.initProductAccordion === 'function') window.initProductAccordion();
          }
        }
      })
      .catch(err => console.error('Error refreshing cart page on cart:updated', err));
  }
});

document.addEventListener('cart:refresh', async () => {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    syncProductCardsWithCart(cart);
  } catch (err) {}
});

document.addEventListener('DOMContentLoaded', async () => {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    syncProductCardsWithCart(cart);
  } catch (err) {}
});

/**
 * 14. Product Variant Selection
 */
function initProductVariants() {
  const container = document.querySelector('[data-variants-container]');
  const variantsJson = document.querySelector('[data-variants-json]');
  const idInput = document.querySelector('[data-product-id-input]');
  const priceEl = document.querySelector('.product-detail__price--current');

  if (!container || !variantsJson || !idInput) return;

  const variants = JSON.parse(variantsJson.textContent);

  // Pre-registrar inventario de todas las variantes
  variants.forEach(v => {
    CartStockManager.registerStock(v.id, v.inventory_quantity, v.inventory_policy, v.inventory_management);
  });

  const swatches = container.querySelectorAll('.variant-swatch');

  const updatePdpStockDisplay = (matchedVariant) => {
    const qtyInput = document.querySelector('[data-qty-input]');
    const plusBtn = document.querySelector('[data-qty-plus]');
    const atcBtn = document.querySelector('button[name="add"]');

    if (!matchedVariant) return;

    const vId = matchedVariant.id;
    const shouldLimit = CartStockManager.shouldLimit(vId);
    const available = CartStockManager.getAvailableToAdd(vId);

    if (shouldLimit) {
      if (qtyInput) {
        qtyInput.max = available > 0 ? available : 1;
        const curVal = parseInt(qtyInput.value) || 1;
        if (curVal > available) {
          qtyInput.value = Math.max(1, available);
        }
      }

      if (plusBtn) {
        const curVal = parseInt(qtyInput?.value) || 1;
        const atMax = available <= 0 || curVal >= available;
        plusBtn.classList.toggle('is-max', atMax);
        plusBtn.disabled = atMax;
      }

      if (atcBtn && available <= 0) {
        atcBtn.disabled = true;
        atcBtn.textContent = 'AGOTADO';
      }
    } else {
      if (qtyInput) qtyInput.removeAttribute('max');
      if (plusBtn) {
        plusBtn.classList.remove('is-max');
        plusBtn.disabled = false;
      }
    }
  };

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      // Update active state in current option row
      swatch.parentElement.querySelectorAll('.variant-swatch').forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');

      // Get current selection
      const currentSelection = [];
      container.querySelectorAll('.product-variant').forEach((row, index) => {
        const active = row.querySelector('.variant-swatch.is-active');
        currentSelection[index] = active ? active.dataset.value : null;
      });

      // Find matching variant
      const matchedVariant = variants.find(v => {
        return v.options.every((opt, i) => opt === currentSelection[i]);
      });

      if (matchedVariant) {
        idInput.value = matchedVariant.id;
        if (priceEl) priceEl.textContent = formatMoney(matchedVariant.price);

        // Update URL
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url.toString());

        // Update button state
        const atcBtn = document.querySelector('button[name="add"]');
        if (atcBtn) {
          if (matchedVariant.available) {
            atcBtn.disabled = false;
            atcBtn.innerHTML = '<span class="btn__icon"></span> AÑADIR AL CARRITO';
          } else {
            atcBtn.disabled = true;
            atcBtn.textContent = 'AGOTADO';
          }
        }

        // Recalcular stock y selector
        updatePdpStockDisplay(matchedVariant);
      }
    });
  });

  // Sincronización inicial para la variante cargada
  const initialVariant = variants.find(v => String(v.id) === String(idInput.value));
  if (initialVariant) {
    updatePdpStockDisplay(initialVariant);
  }
}

/**
 * 14. Recently Viewed Logic
 */
function trackRecentlyViewed() {
  const currentHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/i);
  if (!currentHandle) return;

  const handle = currentHandle[1];
  let history = JSON.parse(localStorage.getItem('recently_viewed')) || [];

  // Remove if already exists to move it to the front
  history = history.filter(h => h !== handle);
  history.unshift(handle);

  // Limit to 12
  history = history.slice(0, 12);

  localStorage.setItem('recently_viewed', JSON.stringify(history));
}

async function initRecentlyViewed() {
  const container = document.querySelector('[data-recently-viewed]');
  if (!container) return;

  const grid = container.querySelector('[data-recently-viewed-container]');
  const limit = parseInt(container.dataset.limit) || 12;
  const history = JSON.parse(localStorage.getItem('recently_viewed')) || [];

  // Filter current product if on product page
  const currentHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/i);
  const filteredHistory = currentHandle ? history.filter(h => h !== currentHandle[1]) : history;

  if (filteredHistory.length === 0) return;

  container.classList.remove('hidden');

  const products = filteredHistory.slice(0, limit);
  const fetchPromises = products.map(handle => 
    fetch(`/products/${handle}?section_id=product-card-endpoint`)
      .then(res => {
        if (!res.ok) throw new Error('Product fetch failed');
        return res.text();
      })
      .catch(() => null)
  );

  try {
    const htmlData = await Promise.all(fetchPromises);
    grid.innerHTML = htmlData.map(html => {
      if (!html || html.trim() === '') return '';
      return `<div class="product-carousel__item">${html}</div>`;
    }).join('');
    
    // Re-init carousels to pick up new cards
    initHorizontalCarousel();
    // Bind the wishlist hearts to the newly injected cards
    if (typeof initWishlistButtons === 'function') {
      initWishlistButtons();
    }

  } catch (err) {
    console.error('Error loading recently viewed products', err);
  }
}


/**
 * 14. Custom Dropdowns (Sort, etc.)
 */
function initCustomDropdowns() {
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  dropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('[data-dropdown-trigger]');
    const menu = dropdown.querySelector('[data-dropdown-menu]');

    if (!trigger || !menu) return;

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');

      // Close all other dropdowns
      document.querySelectorAll('[data-dropdown].is-open').forEach(d => {
        if (d !== dropdown) d.classList.remove('is-open');
      });

      dropdown.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', !isOpen);
    });

    // Close on escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dropdown.classList.contains('is-open')) {
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Close all dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-dropdown].is-open').forEach(dropdown => {
      if (!dropdown.contains(e.target)) {
        dropdown.classList.remove('is-open');
        const trigger = dropdown.querySelector('[data-dropdown-trigger]');
        trigger?.setAttribute('aria-expanded', 'false');
      }
    });
  });
}
/**
 * 15. FAQ Accordion
 */
function initFAQAccordion() {
  const items = document.querySelectorAll('[data-accordion-item]');

  items.forEach(item => {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const content = item.querySelector('[data-accordion-content]');
    if (!trigger || !content) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = item.classList.contains('is-open');

      // Close others in the same group
      const group = item.closest('[data-accordion-group]') || document;
      group.querySelectorAll('[data-accordion-item].is-open').forEach(other => {
        if (other !== item) {
          other.classList.remove('is-open');
          const otherContent = other.querySelector('[data-accordion-content]');
          if (otherContent) otherContent.style.maxHeight = null;
        }
      });

      // Toggle current
      if (isOpen) {
        item.classList.remove('is-open');
        content.style.maxHeight = null;
      } else {
        item.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
}

/**
 * 18. Department Page
 */
function initDepartmentPage() {
  // Mobile accordion
  const mobileToggle = document.querySelector('[data-dept-mobile-toggle]');
  const mobilePanel = document.querySelector('[data-dept-mobile-panel]');
  const mobileIcon = document.querySelector('[data-dept-mobile-icon]');

  if (mobileToggle && mobilePanel) {
    mobileToggle.addEventListener('click', () => {
      const isExpanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', !isExpanded);
      
      if (isExpanded) {
        mobilePanel.classList.remove('is-open');
        mobileToggle.classList.remove('is-active');
      } else {
        mobilePanel.classList.add('is-open');
        mobileToggle.classList.add('is-active');
      }
    });
  }

  // Sidebar accordions
  const sidebarToggles = document.querySelectorAll('[data-dept-sidebar-toggle]');
  sidebarToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const panel = toggle.nextElementSibling;
      const icon = toggle.querySelector('[data-dept-sidebar-icon]');
      
      if (!panel || !panel.hasAttribute('data-dept-sidebar-panel')) return;

      const isHidden = !panel.classList.contains('is-open');
      
      if (isHidden) {
        // Cerrar todos los demás paneles
        sidebarToggles.forEach(otherToggle => {
          if (otherToggle !== toggle) {
            const otherPanel = otherToggle.nextElementSibling;
            if (otherPanel && otherPanel.hasAttribute('data-dept-sidebar-panel')) {
              otherToggle.classList.remove('is-active');
              otherPanel.classList.remove('is-open');
            }
          }
        });

        // Abrir este
        toggle.classList.add('is-active');
        panel.classList.add('is-open');
        
        // Scroll suave para asegurar que el elemento abierto quede visible arriba
        setTimeout(() => {
          const offset = 120; // Compensar por el header sticky de la página
          const y = toggle.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 300); // 300ms para esperar que termine la animación de CSS

      } else {
        toggle.classList.remove('is-active');
        panel.classList.remove('is-open');
      }
    });
  });

  // Carousels
  const carousels = document.querySelectorAll('[data-dept-carousel-wrapper]');
  carousels.forEach(wrapper => {
    const scrollContainer = wrapper.querySelector('[data-dept-carousel-scroll]');
    const prevBtn = wrapper.parentElement.querySelector('[data-dept-carousel-prev]');
    const nextBtn = wrapper.parentElement.querySelector('[data-dept-carousel-next]');

    if (!scrollContainer || !prevBtn || !nextBtn) return;

    // Get item width dynamically
    const updateScrollAmount = () => {
      const firstItem = scrollContainer.querySelector('.dept-carousel__item, .shrink-0');
      if (firstItem) {
        const style = window.getComputedStyle(firstItem);
        return firstItem.offsetWidth + parseInt(style.marginRight || 0) + 16; // 16px is the gap
      }
      return 201; // Fallback
    };

    const updateButtonStates = () => {
      const atStart = scrollContainer.scrollLeft <= 5;
      const atEnd = scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth - 5;
      
      prevBtn.style.opacity = atStart ? '0.15' : '1';
      prevBtn.style.pointerEvents = atStart ? 'none' : 'auto';
      
      nextBtn.style.opacity = atEnd ? '0.15' : '1';
      nextBtn.style.pointerEvents = atEnd ? 'none' : 'auto';
    };

    scrollContainer.addEventListener('scroll', updateButtonStates, { passive: true });
    
    // Initial check
    setTimeout(updateButtonStates, 100);

    prevBtn.addEventListener('click', () => {
      scrollContainer.scrollBy({ left: -updateScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      scrollContainer.scrollBy({ left: updateScrollAmount(), behavior: 'smooth' });
    });
  });
}

/**
 * =============================================================================
 * FAVORITES (WISHLIST) LOGIC
 * =============================================================================
 */

const WISHLIST_KEY = 'pz_wishlist';

function getWishlist() {
  try {
    const list = localStorage.getItem(WISHLIST_KEY);
    return list ? JSON.parse(list) : [];
  } catch (e) {
    return [];
  }
}

function saveWishlist(list) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: list }));
}

function initWishlistButtons() {
  const buttons = document.querySelectorAll('.product-card__wishlist, .product-detail__wishlist');
  const currentList = getWishlist();

  buttons.forEach(btn => {
    const handle = btn.dataset.productHandle;
    if (!handle) return;

    // Set initial state
    if (currentList.includes(handle)) {
      btn.classList.add('is-active');
    } else {
      btn.classList.remove('is-active');
    }

    // Attach click event if not already attached
    if (!btn.dataset.wishlistInitialized) {
      btn.dataset.wishlistInitialized = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const list = getWishlist();
        const index = list.indexOf(handle);

        if (index > -1) {
          // Remove
          list.splice(index, 1);
          btn.classList.remove('is-active');
        } else {
          // Add
          list.push(handle);
          btn.classList.add('is-active');
        }

        saveWishlist(list);
      });
    }
  });
}

// Sincronizar reactivamente todos los botones en la página cuando cambie la lista de favoritos
document.addEventListener('wishlist:updated', (e) => {
  const currentList = e.detail;
  const buttons = document.querySelectorAll('.product-card__wishlist, .product-detail__wishlist');
  buttons.forEach(btn => {
    const handle = btn.dataset.productHandle;
    if (handle) {
      if (currentList.includes(handle)) {
        btn.classList.add('is-active');
      } else {
        btn.classList.remove('is-active');
      }
    }
  });
});

async function initFavoritesPage() {
  const container = document.querySelector('[data-favorites-page]');
  if (!container) return; // Not on the favorites page

  const grid = container.querySelector('[data-favorites-grid]');
  const emptyState = container.querySelector('[data-favorites-empty]');
  const countEl = container.querySelector('[data-favorites-count]');
  const addAllBtn = container.querySelector('[data-favorites-add-all]');

  if (!grid || !emptyState || !countEl) return;

  if (addAllBtn) {
    addAllBtn.addEventListener('click', async () => {
      // FIX: cada producto puede tener MAS DE UN boton [data-add-to-cart]
      // (el de la tarjeta y el del Quick View). Filtramos los repetidos
      // para no añadir el mismo producto dos veces.
      const atcButtons = grid.querySelectorAll('[data-add-to-cart]');
      const vistos = new Set();
      const items = [];
      let omittedCount = 0;

      atcButtons.forEach(btn => {
        const id = parseInt(btn.dataset.variantId);
        if (!id || vistos.has(id)) return;
        vistos.add(id);

        CartStockManager.registerStock(
          id,
          btn.dataset.inventoryQty,
          btn.dataset.inventoryPolicy,
          btn.dataset.inventoryManagement
        );

        if (CartStockManager.shouldLimit(id)) {
          const available = CartStockManager.getAvailableToAdd(id);
          if (available > 0) {
            items.push({ id: id, quantity: Math.min(1, available) });
          } else {
            omittedCount++;
          }
        } else {
          items.push({ id: id, quantity: 1 });
        }
      });

      if (items.length === 0) {
        window.showPuntazoToast('No hay unidades adicionales disponibles para los productos seleccionados.', 'info');
        return;
      }

      const originalText = addAllBtn.innerHTML;

      // Optimistic UI: Mostrar éxito al instante
      addAllBtn.innerHTML = '✅ ¡Añadidos!';
      addAllBtn.style.backgroundColor = '#25D366'; // Verde éxito

      // Optimistic Badge: Sumar la cantidad de items
      const badge = document.querySelector('[data-cart-count]');
      if (badge) {
        let count = parseInt(badge.textContent) || 0;
        badge.textContent = count + items.length;
        badge.style.display = 'flex';
      }

      // Background Sync
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      }).then(async res => {
        if (!res.ok) throw new Error('Failed to add all items');
        if (typeof updateCartBadge === 'function') updateCartBadge();
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        if (omittedCount > 0) {
          window.showPuntazoToast(`Se añadieron ${items.length} productos. ${omittedCount} no tenían stock adicional.`, 'info');
        }

        setTimeout(() => {
          addAllBtn.innerHTML = originalText;
          addAllBtn.style.backgroundColor = '';
        }, 2500);
      }).catch(err => {
        console.error('Error adding all to cart', err);
        addAllBtn.innerHTML = '❌ Error';
        addAllBtn.style.backgroundColor = '#dc2626';
        if (typeof updateCartBadge === 'function') updateCartBadge();

        setTimeout(() => {
          addAllBtn.innerHTML = originalText;
          addAllBtn.style.backgroundColor = '';
        }, 2500);
      });
    });
  }

  const renderFavorites = async () => {
    const handles = getWishlist();

    // Update counter
    const updateUI = (len) => {
      if (len === 0) {
        countEl.textContent = 'No tienes productos guardados';
        if (addAllBtn) addAllBtn.hidden = true;
      } else {
        countEl.textContent = `${len} ${len === 1 ? 'producto guardado' : 'productos guardados'}`;
        if (addAllBtn) addAllBtn.hidden = false;
      }
    };

    updateUI(handles.length);

    if (handles.length === 0) {
      grid.style.display = 'none';
      emptyState.hidden = false;
      return;
    }

    grid.style.display = 'grid';
    emptyState.hidden = true;
    grid.innerHTML = '<div style="grid-column: 1 / -1; text-align: center; padding: 2rem;">Cargando productos...</div>';

    try {
      const promises = handles.map(handle =>
        fetch(`/products/${handle}?section_id=product-card-endpoint`)
          .then(res => {
            if (!res.ok) throw new Error('Product fetch failed');
            return res.text();
          })
          .catch((e) => {
            console.error('Failed to parse HTML for', handle, e);
            return null;
          })
      );

      const results = await Promise.all(promises);

      grid.innerHTML = '';

      results.forEach((html, index) => {
        if (html && html.trim().length > 0) {
          const handle = handles[index];
          // Wrap html in a div to manage removal animations
          const wrapper = document.createElement('div');
          wrapper.className = 'favorites__grid-item';
          wrapper.dataset.handle = handle;
          wrapper.innerHTML = html;
          grid.appendChild(wrapper);
        }
      });

      // Re-initialize buttons for newly injected HTML
      initWishlistButtons();

    } catch (err) {
      console.error('Error fetching favorite products', err);
      grid.innerHTML = '<div style="grid-column: 1 / -1; text-align: center;">Error al cargar productos.</div>';
    }
  };

  // Initial render
  await renderFavorites();

  // Listen to global changes to handle removal from the favorites page itself
  document.addEventListener('wishlist:updated', (e) => {
    const list = e.detail;

    // Update counter
    if (list.length === 0) {
      countEl.textContent = 'No tienes productos guardados';
      if (addAllBtn) addAllBtn.hidden = true;
    } else {
      countEl.textContent = `${list.length} ${list.length === 1 ? 'producto guardado' : 'productos guardados'}`;
      if (addAllBtn) addAllBtn.hidden = false;
    }

    if (list.length === 0) {
      grid.style.display = 'none';
      emptyState.hidden = false;
    } else {
      // Find items in the grid that are no longer in the list
      const items = grid.querySelectorAll('.favorites__grid-item');
      items.forEach(item => {
        const handle = item.dataset.handle;
        if (!list.includes(handle)) {
          // It was removed
          const card = item.querySelector('.product-card');
          if (card) {
            card.classList.add('is-removing');
            setTimeout(() => {
              item.remove();
            }, 280);
          } else {
            item.remove();
          }
        }
      });
    }
  });
}

// ============================================================================
// 12. ABOUT BRANDS CAROUSEL
// ============================================================================
function initAboutBrandsCarousel() {
  const container = document.querySelector('.about-brands__carousel');
  const track = document.querySelector('.about-brands__track');
  if (!container || !track) return;

  if (container.dataset.initialized) return;
  container.dataset.initialized = "true";

  const originalItems = Array.from(track.children);
  if (originalItems.length === 0) return;

  const originalCount = originalItems.length;
  const loopedCount = originalCount * 3;
  
  for (let i = 0; i < 2; i++) {
    originalItems.forEach(item => {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });
  }

  const allItems = Array.from(track.children);
  
  let visible = window.innerWidth < 500 ? 2 : 3;
  let index = originalCount; 
  let animated = true;

  function updateVisible() {
    visible = window.innerWidth < 500 ? 2 : 3;
    render();
  }

  window.addEventListener('resize', updateVisible);

  function render() {
    const trackWidth = (loopedCount / visible) * 100;
    track.style.width = `${trackWidth}%`;
    track.style.transition = animated ? 'transform 0.5s ease' : 'none';
    
    const translateX = -((index / loopedCount) * 100);
    track.style.transform = `translateX(${translateX}%)`;

    allItems.forEach(item => {
      item.style.width = `${100 / loopedCount}%`;
      item.style.padding = '0 10px';
    });
  }

  render();

  setInterval(() => {
    // Asegurarse de que la transición esté activa antes de avanzar
    track.style.transition = 'transform 0.5s ease';
    index++;
    
    // Aplicar movimiento
    const translateX = -((index / loopedCount) * 100);
    track.style.transform = `translateX(${translateX}%)`;

    if (index >= originalCount * 2) {
      setTimeout(() => {
        // Desactivar transición para el salto instantáneo
        track.style.transition = 'none';
        index = originalCount;
        
        // Aplicar el salto instantáneo de vuelta al centro
        const resetTranslate = -((index / loopedCount) * 100);
        track.style.transform = `translateX(${resetTranslate}%)`;
        
        // Forzar reflow del navegador para aplicar el salto inmediatamente
        track.offsetHeight;
      }, 500); // esperar a que termine la animación actual
    }
  }, 5000);
}

document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.about-brands__track');
  if (track && track.children.length > 0) {
    initAboutBrandsCarousel();
  } else {
    document.addEventListener('puntazo:brands:ready', initAboutBrandsCarousel);
  }
});

/**
 * 23. Quick View Modal
 */
function initQuickView() {
  document.body.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-view]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const handle = btn.getAttribute('data-quick-view');
    if (!handle) return;

    const card = btn.closest('[data-product-card]');
    if (!card) return;

      const modal = card.querySelector(`[data-quick-view-modal-handle="${handle}"]`);
      if (!modal) return;

      // Evitamos añadir múltiples listeners de cierre a los mismos elementos
      if (!modal.dataset.initialized) {
        modal.dataset.initialized = 'true';

        const closeBtns = modal.querySelectorAll('[data-quick-view-close]');
        closeBtns.forEach(c => {
          c.addEventListener('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            modal.close();
            body.style.overflow = '';
          });
        });

        // Click fuera del modal para cerrarlo
        modal.addEventListener('click', (ev) => {
          if (ev.target === modal) {
            modal.close();
            body.style.overflow = '';
          }
        });
      }

      modal.showModal();
      body.style.overflow = 'hidden';

      // Thumbnails logic was moved to a delegated event listener

    });

  // Delegación de eventos para los Thumbnails del Quick View
  document.body.addEventListener('click', (ev) => {
    const thumb = ev.target.closest('[data-qv-thumb]');
    if (!thumb) return;

    const modal = thumb.closest('.quick-view-modal');
    if (!modal) return;

    ev.preventDefault();
    ev.stopPropagation();

    const mainImage = modal.querySelector('[data-qv-main-image]');
    const thumbs = modal.querySelectorAll('[data-qv-thumb]');

    thumbs.forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');

    if (mainImage) {
      mainImage.src = thumb.getAttribute('data-qv-thumb');
    }
  });

}
